import React from "react";
import { LayoutGrid, List, LogOut, User } from "lucide-react";
import { chapters } from "../data/chapters";
import { useAuth } from "../context/AuthContext";

export default function Sidebar({ activeChapterId, onChapterSelect, isAdaptive, onAdaptiveSelect, isMap, onMapSelect }) {
  const { currentUser, logout } = useAuth();
  return (
    <aside className="w-60 min-h-screen bg-gray-50 border-r border-gray-200 flex flex-col shrink-0">
      {/* Logo */}
      <div className="flex items-center gap-2 px-4 py-4 border-b border-gray-200">
        <span className="text-base font-semibold text-gray-800">BJT刷题</span>
        <LayoutGrid size={16} className="text-gray-400 ml-auto cursor-pointer hover:text-gray-600" />
      </div>

      {/* Chapter List */}
      <div className="px-4 pt-3 flex-1 overflow-y-auto">
        <div className="flex items-center gap-1.5 mb-2">
          <List size={14} className="text-gray-400" />
          <p className="text-xs text-gray-400 font-medium">章节列表</p>
          <div className="w-3.5 h-3.5 rounded-full bg-gray-200 flex items-center justify-center ml-0.5">
            <span className="text-[9px] text-gray-500">i</span>
          </div>
        </div>

        <nav className="flex flex-col gap-0.5">
          {chapters.filter(c => [7, 8, 9].includes(c.id)).map((chapter) => {
            const isActive = chapter.id === activeChapterId;
            return (
              <button
                key={chapter.id}
                onClick={() => onChapterSelect(chapter.id)}
                className={`w-full text-left rounded-lg px-3 py-2 transition-colors ${
                  isActive ? "bg-indigo-50 text-indigo-700" : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <p className={`text-sm font-medium truncate ${isActive ? "text-indigo-700" : ""}`}>
                  {chapter.title}
                </p>
                <p className={`text-xs mt-0.5 ${isActive ? "text-indigo-400" : "text-gray-400"}`}>
                  {chapter.pages}
                </p>
              </button>
            );
          })}


          {chapters.filter(c => ![7, 8, 9].includes(c.id)).map((chapter) => {
            const isActive = chapter.id === activeChapterId;
            return (
              <button
                key={chapter.id}
                onClick={() => onChapterSelect(chapter.id)}
                className={`w-full text-left rounded-lg px-3 py-2 transition-colors ${
                  isActive ? "bg-indigo-50 text-indigo-700" : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <p className={`text-sm font-medium truncate ${isActive ? "text-indigo-700" : ""}`}>
                  {chapter.title}
                </p>
                <p className={`text-xs mt-0.5 ${isActive ? "text-indigo-400" : "text-gray-400"}`}>
                  {chapter.pages}
                </p>
              </button>
            );
          })}

          {/* Separator */}
          <div className="my-1 border-t border-gray-200" />

          {/* 知识地图 */}
          <button
            onClick={onMapSelect}
            className={`w-full text-left rounded-lg px-3 py-2 transition-colors ${
              isMap
                ? "bg-indigo-50 text-indigo-700"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            <p className={`text-sm font-medium ${isMap ? "text-indigo-700" : ""}`}>
              知识点地图
            </p>
            <p className={`text-xs mt-0.5 ${isMap ? "text-indigo-400" : "text-gray-400"}`}>
              探索已练习的知识点
            </p>
          </button>

          {/* 自适应测试 */}
          <button
            onClick={onAdaptiveSelect}
            className={`w-full text-left rounded-lg px-3 py-2 transition-colors ${
              isAdaptive
                ? "bg-indigo-50 text-indigo-700"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            <p className={`text-sm font-medium ${isAdaptive ? "text-indigo-700" : ""}`}>
              能力自测
            </p>
            <p className={`text-xs mt-0.5 ${isAdaptive ? "text-indigo-400" : "text-gray-400"}`}>
              IRT 自动推题
            </p>
          </button>
        </nav>
      </div>

      {/* 当前用户 + 退出 */}
      {currentUser && (
        <div className="px-4 py-3 border-t border-gray-200 shrink-0">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-indigo-100 flex items-center justify-center shrink-0">
              <User size={13} className="text-indigo-500" />
            </div>
            <span className="text-sm text-gray-700 font-medium truncate flex-1">
              {currentUser.username}
            </span>
            <button
              onClick={logout}
              title="退出登录"
              className="p-1 rounded-md text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors"
            >
              <LogOut size={15} />
            </button>
          </div>
        </div>
      )}
    </aside>
  );
}
